import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { CustomerInfo } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'
import { ProgramCoverageBreakdown } from '@lyrahealth-inc/shared-app-logic/src/models/user/User'

import { getRequestPaymentCustomerProgramCoverageBreakdown } from '../../../../data/requestPayment/requestPaymentSelectors'
import { getCustomerProgramCoverageBreakdown } from '../../../../requestPayment/data/requestPaymentActions'
import { useCustomersForClient } from '../data/hooks/useCustomersForClient'

/**
 * Hook to get program coverage breakdown for a customer
 *
 * @param customerName The name of the customer to get program coverage breakdown for
 * @returns The program coverage breakdown for the customer
 */
export const useProgramCoverageBreakdown = (
  customerName?: string,
  country?: string,
): ProgramCoverageBreakdown | undefined => {
  const dispatch = useDispatch()
  const customers = useCustomersForClient()

  const programCoverageBreakdown = useSelector((state) =>
    getRequestPaymentCustomerProgramCoverageBreakdown(state, customerName, country),
  )

  // Find the customer in the existing customers list
  const customer = customerName
    ? customers?.find((customer: CustomerInfo) => customer.value.toLowerCase() === customerName.toLowerCase())
    : undefined

  // fetch from v1/customers/program-coverage-breakdown API if data is not available
  useEffect(() => {
    if (customerName && customer && !programCoverageBreakdown) {
      dispatch(getCustomerProgramCoverageBreakdown(customerName, country))
    }
  }, [customerName, customer, country, programCoverageBreakdown, dispatch])

  return programCoverageBreakdown
}
